import IconGlowWrapper from '@/app/components/IconGlowWrapper'
import { useGame } from '@/app/providers/GameContextProvider'
import useIsMobile from '@/hooks/useIsMobile';
import { useTranslation } from '@/hooks/useTranslation'
import { GameStep } from '@/lib/types/common/GameStep';
import React from 'react'
import { GiSwordWound } from 'react-icons/gi';

const ServerInfoDamageMultiplier = () => {
    const { gameState } = useGame()
    const { t } = useTranslation()
    const isMobile = useIsMobile();

    const damageMultiplier = gameState?.currentDamageMultiplier;

    if (!gameState || damageMultiplier === undefined || !gameState.isEffectivelyFight) return null
    if (gameState?.gameStep !== GameStep.GUESSING && gameState?.gameStep !== GameStep.RESULT) return null;

    return (
        <div className="flex gap-2 items-center">
            <IconGlowWrapper icon={<GiSwordWound />} className="text-[18px] md:text-[22px] translate-y-[-1px] pointer-events-none" color="yellow" />
            <span className="text-xs xl:text-base">{isMobile ? t("play.fight.mobileDamageMultiplier") : t("play.fight.damageMultiplier")}: {damageMultiplier.toFixed(2)}x</span>
        </div>
    )
}

export default ServerInfoDamageMultiplier